import { Tag } from '@chakra-ui/react';

import { BadgeProps } from './badge.props';

export const Badge = ({
    icon,
    url,
    children,
    noWrap = true,
    rightElement,
    labelProps,
    dangerouslySetInnerHTML,
    ...props
}: BadgeProps): JSX.Element => {
    const childrenProp = {
        ...(dangerouslySetInnerHTML && {
            dangerouslySetInnerHTML,
        }),
        ...(children && {
            children,
        }),
    };

    const innerContent = (
        <>
            {icon ? <Tag.StartElement>{icon}</Tag.StartElement> : null}
            <Tag.Label {...labelProps} lineClamp={noWrap ? 1 : 0} {...childrenProp} />
            {rightElement}
        </>
    );

    return (
        <Tag.Root asChild={!!url} {...props}>
            {url ? <a href={url}>{innerContent}</a> : innerContent}
        </Tag.Root>
    );
};
